module.exports = __webpack_public_path__ + "img/coolingtower.d25294a9.svg";